import { ConfirmOption } from 'containers/global_state_container'
import { User } from 'entities/user'
import React, { ReactNode, SetStateAction } from 'react'

export type NotificationColor = 'success' | 'danger' | 'warning' | 'info'

type GlobalState = {
    user: User
    setUser: (value: SetStateAction<User>) => void
    users: User[]
    setUsers: (value: SetStateAction<User[]>) => void
    loading: boolean
    setLoading: (value: SetStateAction<boolean>) => void
    apiError: { [key: string]: string }
    setError: (value: SetStateAction<{ [key: string]: string }>) => void
    notificationMessage: { body: string | ReactNode }
    setNotificationMessage: (value: SetStateAction<{ body: string | ReactNode; colorType?: NotificationColor; title?: string; delay?: number }>) => void
    showConfirm: (message: ReactNode, callback?: () => void, option?: ConfirmOption) => void
}

export const initialGlobalState: GlobalState = {
    user: {},
    setUser: () => {},
    users: [],
    setUsers: () => {},
    loading: false,
    setLoading: () => {},
    apiError: {},
    setError: () => {},
    notificationMessage: { body: '' },
    setNotificationMessage: () => {},
    showConfirm: () => {},
}

export const GlobalStateContext = React.createContext(initialGlobalState)
